<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-md="true"
    :is-loading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="assignForm">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="priority"
              label="کد ملی راننده"
              validation-container-class="col-12 col-md-6"
              rules="required|irani"
              input-class="form-control"
              v-model="dataForm.national_code"
              :disabled="step != 1"
            />
            <bita-input
              type="text"
              name="priority"
              label="شماره هوشمند ماشین"
              validation-container-class="col-12 col-md-6"
              rules="required|digits:7"
              input-class="form-control"
              v-model="dataForm.smart_number"
              :disabled="step != 1"
            />
            <bita-input
              type="text"
              name="priority"
              label="شماره تماس راننده"
              validation-container-class="col-12 col-md-6"
              rules="required|mobile"
              input-class="form-control"
              v-model="dataForm.phone"
              :disabled="step != 1"
            />
            <div class="col-12">
              <bita-bootbutton
                type="primary"
                title="ارسال اطلاعات"
                icon="fa fa-check"
                class="w-100"
                :loading="loading && step == 1"
                @click.native="checkDriver()"
              />
            </div>
          </div>
        </div>
      </bita-form>

      <!-- Register Driver -->
      <bita-form ref="registerForm">
        <div slot="body">
          <div class="register-form" v-if="step != 1">
            <div class="row mt-3">
              <bita-input
                type="text"
                name="priority"
                label="کد تایید"
                validation-container-class="col-12 col-md-6"
                rules="required|digits:4"
                input-class="form-control"
                :disabled="step != 2"
                v-model="registerForm.otp"
              />

              <div class="col-12">
                <bita-bootbutton
                  type="primary"
                  title="تخصیص بار"
                  icon="fa fa-check"
                  class="w-100"
                  :loading="loading && step != 1"
                  @click.native="assignRequestToDriver()"
                />
              </div>
            </div>
          </div>
        </div>
      </bita-form>
    </div>
  </bita-modal>
</template>
<script>
import LabelValue from "./LabelValue";

export default {
  components: { LabelValue },
  props: {
    modalId: {},
    title: {},
    isLoading: {},
  },
  data() {
    return {
      requestDetail: {},
      dataForm: {},
      registerForm: {},
      step: 1,
      loading: false,
    };
  },
  methods: {
    onCloseModal() {
      this.dataForm = {};
      this.registerForm = {};
      this.requestDetail = {};
      this.step = 1;

      //Reset Form
      this.reset();
    },

    assignRequestToDriver() {
      this.$refs.registerForm.validate().then((result) => {
        if (result && this.step == 2) {
          this.loading = true;

          this.$persistClient(
            "post",
            `request-details/${this.requestDetail.id}/assign`,
            {
              phone: this.dataForm.phone,
              national_code: this.dataForm.national_code,
              smart_number: this.dataForm.smart_number,
              otp: this.registerForm.otp,
            }
          )
            .then((res) => {
              this.$toggleModal(`#${this.modalId}`);

              this.$emit("get:requestDetails");
            })
            .finally(() => (this.loading = false));
        }
      });
    },

    checkDriver() {
      this.$refs.assignForm.validate().then((result) => {
        if (result) {
          this.loading = true;

          this.$persistClient(
            "post",
            `request-details/${this.requestDetail.id}/check-driver`,
            this.dataForm
          )
            .then((res) => {
              this.step = 2;
            })
            .catch(() => {})
            .finally(() => (this.loading = false));
        }
      });
    },

    init({ requestDetail }) {
      this.requestDetail = requestDetail;
    },

    reset() {
      this.$refs.assignForm.reset();
      this.$refs.registerForm.reset();
    },
  },
};
</script>
